'use client';

import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { useParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { ShopEmptyState } from '../EmptyState';

import { RepopEmptyState } from '@/app/[locale]/[username]/(shop)/components/RepopEmptyState';
import { useRepopOnEmptyShop } from '@/modules/shop/hooks/useRepopOnEmptyShop';

export function SellingProductsEmptyState() {
  const t = useTranslations('shop');
  const { username } = useParams<{ username: string; locale: string }>();
  const { products, showProducts } = useRepopOnEmptyShop();

  if (showProducts) {
    return <RepopEmptyState products={products} />;
  }

  return (
    <ShopEmptyState>
      <Body variant="sm-regular">{t('NoProducts', { username })}</Body>
    </ShopEmptyState>
  );
}
